<template>
  <card v-loading="loading.team">
    <template v-slot:header>
      Team <i v-if="payload.is_sale" class="el-icon-shopping-cart-full"></i>
    </template>
    <el-form label-position="left" label-width="250px" size="small">
      <el-form-item label="Created at">
        <div class="block">
          <el-date-picker v-model="payload.created_at" type="datetime">
          </el-date-picker>
        </div>
      </el-form-item>
      <el-form-item label="Name">
        <el-input v-model="payload.name" />
      </el-form-item>
      <el-form-item label="Owner Email">
        <el-input v-model="ownerDetails.email" readonly />
      </el-form-item>
      <el-form-item label="Active projects count">
        <el-input-number v-model="payload.active_projects_count" :min="0" :step="1" step-strictly />
      </el-form-item>
      <el-form-item label="Billing period">
        <el-select v-model="payload.billing_period">
          <el-option value="monthly" label="monthly" />
          <el-option value="annually" label="annually" />
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="Start trial">
        <el-switch v-model="payload.did_start_trial"></el-switch>
      </el-form-item> -->
      <!-- <el-form-item label="Invitations">
        <el-select
          v-model="payload.invitations"
          multiple
          filterable
          allow-create
          default-first-option
        >
          <el-option
            v-for="(item, index) in payload.invitations"
            :key="index"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="Agency">
        <el-switch v-model="payload.is_agency"></el-switch>
      </el-form-item>
      <el-form-item label="Archived">
        <el-switch v-model="payload.is_archived"></el-switch>
      </el-form-item>
      <el-form-item label="Default">
        <el-switch v-model="payload.is_default"></el-switch>
      </el-form-item>
      <el-form-item label="Including admin seat">
        <el-switch v-model="payload.is_including_admin_seat"></el-switch>
      </el-form-item>
      <el-form-item label="School">
        <el-switch v-model="payload.is_school"></el-switch>
      </el-form-item>
      <el-form-item label="Disable pixel">
        <el-switch v-model="payload.disable_pixel"></el-switch>
      </el-form-item>
      <el-form-item v-if="!team.uses_stigg_integration" label="Sale">
        <el-col :span="8">
          <el-tooltip :disabled="!isSaleDisabled"
            content="Please fill in the fields: Projects count, Seats count, Screen  count and Annual Size deal to enable button">
            <el-switch :disabled="isSaleDisabled" v-model="payload.is_sale"></el-switch>
          </el-tooltip>
        </el-col>
        <el-col v-if="payload.is_sale" :span="4">Sale date</el-col>
        <el-col v-if="payload.is_sale" :span="12">
          <el-date-picker type="date" placeholder="Pick a day" v-model="payload.sale_date"
            style="width: 100%"></el-date-picker>
        </el-col>
      </el-form-item>
      <el-form-item v-if="!team.uses_stigg_integration" label="Annual size deal">
        <el-input-number v-model="payload.annual_deal_size" :precision="2" :min="0" step-strictly />
      </el-form-item>
      <!-- <el-form-item label="Members">
        <el-select
          v-model="payload.members"
          multiple
          filterable
          allow-create
          default-first-option
        >
          <el-option
            v-for="(item, index) in payload.members"
            :key="index"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item v-if="!team.uses_stigg_integration" label="Premium website purchase count">
        <el-input-number v-model="payload.premium_website_purchase_count" :min="0" :step="1" step-strictly />
      </el-form-item>
      <el-form-item v-if="!team.uses_stigg_integration" label="Projects limit count">
        <el-col :span="12">
          <el-tooltip :disabled="!isProjectsLimitDisabled" content="Please fill check if there's an active subscription">
            <el-select :disabled="isProjectsLimitDisabled" v-model="projectLimitOption"
              @change="updateProjectsLimitCount()">
              <el-option v-for="item in projectLimitOptions" :key="item.value" :label="item.label" :value="item.value"
                :disabled="item.disabled" />
            </el-select>
          </el-tooltip>
        </el-col>
        <el-col :span="11" :offset="1">
          <el-input-number v-model="payload.projects_limit_count"
            :style="hideProjectLimitCount ? { display: 'none' } : {}" :min="-1" :step="1" step-strictly /></el-col>
      </el-form-item>
      <el-form-item v-if="!team.uses_stigg_integration" label="Seats count">
        <el-col :span="5">
          <el-input-number v-model="payload.seats_count" :min="0" :step="1" step-strictly />
        </el-col>
        <el-col :span="18" :offset="1">
          <span class="mx-1">We currently have {{ countActiveMemberships }} seats used</span>
        </el-col>
      </el-form-item>
      <el-form-item v-if="!team.uses_stigg_integration" label="Screen limit count">
        <el-col :span="12">
          <el-tooltip content="Please fill check if there's an active subscription">
            <el-select v-model="screenLimitOption" @change="updateScreensLimitCount()">
              <el-option v-for="item in screenLimitOptions" :key="item.value" :label="item.label" :value="item.value"
                :disabled="item.disabled" />
            </el-select>
          </el-tooltip>
        </el-col>
        <el-col :span="11" :offset="1">
          <el-input-number v-model="payload.screens_limit_count" :style="hideScreenLimitCount ? { display: 'none' } : {}"
            :min="-1" :step="1" step-strictly /></el-col>
      </el-form-item>
      <el-form-item label="Slug">
        <el-input v-model="payload.slug" />
      </el-form-item>
      <el-form-item label="Stripe customer ID">
        <el-input v-model="payload.stripe_customer_id" />
      </el-form-item>
      <el-form-item label="Uses stigg">
        <el-col :span="2">
          <i v-if="team.uses_stigg_integration" class="el-icon-circle-check" />
          <i v-else class="el-icon-circle-close" />
        </el-col>
        <el-col :span="22">
          <el-link v-if="team.uses_stigg_integration" type="primary" @click="openStiggCustomer">See on stigg</el-link>
        </el-col>
      </el-form-item>
      <el-form-item v-if="team.uses_stigg_integration" label="Is payin in stigg">
        <i v-if="payingTeam" class="el-icon-circle-check" />
        <i v-else class="el-icon-circle-close" />
      </el-form-item>
      <el-form-item label="Updated at">
        <div class="block">
          <el-date-picker v-model="payload.updated_at" type="datetime">
          </el-date-picker>
        </div>
      </el-form-item>
      <el-form-item label="Stripe" v-if="payload.stripe_customer_id">
        <el-link :href="stripeUrl" target="_blank">View on Stripe</el-link>
      </el-form-item>
      <el-form-item label="Storybook token">
        <el-input v-model="payload.storybook_token" />
      </el-form-item>
      <el-form-item label="Storybook file id">
        <el-input v-model="payload.storybook_file_id" />
      </el-form-item>
      <el-form-item label="Storybook components limit">
        <el-input-number v-model="payload.storybook_components_limit" :min="0" :step="1" step-strictly />
      </el-form-item>
      <el-form-item label="Should use upload proxy in storybook">
        <el-switch v-model="payload.storybook_use_anima_proxy"></el-switch>
      </el-form-item>
      <el-form-item label="Use storybook to figma V2">
        <el-switch v-model="payload.use_storybook_v2"></el-switch>
      </el-form-item>
      <el-form-item label="Create Subscription">
        <el-button @click="showSubscriptionDialog = true">Create a new subscription</el-button>
      </el-form-item>
      <el-form-item label="Sync team data">
        <el-button @click="syncTeamData">Sync</el-button>
      </el-form-item>
      <el-form-item label="Actions">
        <el-button @click="save" type="primary">Save</el-button>
      </el-form-item>
    </el-form>

    <subscription-dialog :item="team" :isOpen="showSubscriptionDialog"
      :onClose="() => (showSubscriptionDialog = false)" />
  </card>
</template>

<script>
import { pick, defaults } from "lodash";
import { mapGetters, mapActions, mapMutations } from "vuex";
import { stripeUrl } from "@/utils/urls";
import Card from "@/components/Card";
import SubscriptionDialog from "../SubscriptionDialog.vue";
import { isPayingTeam, getCustomerLink } from '@/services/stigg'

export default {
  data() {
    return {
      updatedProjectsLimitCount: false,
      projectsLimit: null,
      stripeCustomerID: null,
      showSubscriptionDialog: false,
      projectLimitOption: "free",
      screenLimitOption: "free",
      screenLimitOptions: [
        {
          count: 5,
          label: "5 (Free plan)",
          value: "free",
        },
        {
          count: 15,
          label: "15 (Pro plan)",
          value: "pro",
        },
        { count: 15, label: "Custom", value: "custom", showCustom: true },
        {
          count: -1,
          label: "Unlimited",
          value: "unlimited",
        },
      ],
      projectLimitOptions: [
        {
          count: 1,
          label: "1 (Free plan)",
          value: "free",
          showCustom: false,
        },
        {
          count: 3,
          label: "3 (Pro plan)",
          value: "pro",
          showCustom: true,
        },
        { count: 3, label: "Custom", value: "custom", showCustom: true },
        {
          count: -1,
          label: "Unlimited",
          value: "unlimited",
          showCustom: false,
        },
      ],
      action: {
        text: "View on webapp",
        callback: () => {
          const { team } = this;
          window.open(
            `https://projects.animaapp.com/team/${team.slug}`,
            "_blank"
          );
        },
      },
      payload: {},
      payingTeam: false,
    };
  },
  components: {
    Card,
    SubscriptionDialog,
  },
  async mounted() {
    this.fetchData();
  },
  computed: {
    ...mapGetters(["team", "teamMemberships", "teamSubscriptions", "loading"]),
    stripeUrl() {
      const { stripe_customer_id } = this.team;
      return stripeUrl(stripe_customer_id);
    },
    ownerDetails() {
      return this.payload.ownerDetails || {};
    },
    isSaleDisabled() {
      return (
        this.payload.projects_limit_count === 1 ||
        !this.payload.screens_limit_count ||
        !this.payload.annual_deal_size ||
        !this.payload.seats_count
      );
    },
    isProjectsLimitDisabled() {
      return (
        this.stripeSubscriptions?.length + this.paypalSubscriptions?.length ===
        0
      );
    },
    getDefaultProjectLimitCount() {
      return this.projectLimitOptions.find(
        (option) => option.value === this.projectLimitOption
      );
    },
    hideProjectLimitCount() {
      return !this.getDefaultProjectLimitCount?.showCustom;
    },
    getDefaultScreenLimitCount() {
      return this.screenLimitOptions.find(
        (option) => option.value === this.screenLimitOption
      );
    },
    countActiveMemberships() {
      return this.teamMemberships.filter(member => member.access_level !== 'viewer').length;
    },
    hideScreenLimitCount() {
      return !this.getDefaultScreenLimitCount?.showCustom;
    },
    stripeSubscriptions() {
      return this.teamSubscriptions.stripe;
    },
    paypalSubscriptions() {
      return this.teamSubscriptions.paypal;
    },
  },
  methods: {
    ...mapActions(["getTeam", "updateTeam", "syncTeamData"]),
    ...mapMutations(["unsetLoading"]),
    async fetchData() {
      const { query: id } = this.$route.params;
      await this.getTeam(id);
      this.projectsLimit = this.team.projects_limit_count;
      this.stripeCustomerID = this.team.stripe_customer_id;
      this.payload = { ...this.team };
      this.projectLimitOption =
        this.projectLimitOptions.find(
          (option) => option.count === this.payload.projects_limit_count
        )?.value || "custom";
      this.screenLimitOption =
        this.screenLimitOptions.find(
          (option) => option.count === this.payload.screens_limit_count
        )?.value || "custom";
      if (this.team.uses_stigg_integration) {
        isPayingTeam(this.team.id).then((payingTeam) => {
          this.payingTeam = payingTeam;
        });
      }
    },
    async syncTeamData() {
      const { id } = this.team;
      await this.$api.post(`/cs/teams/${id}/sync`, {});
      this.$notify.success({
        title: "Team synced",
      });
    },
    async save() {
      try {
        const { id } = this.payload;
        const payload = pick(this.payload, [
          "created_at",
          "name",
          "active_projects_count",
          "billing_period",
          // "did_start_trial",
          // "invitations",
          "is_agency",
          "is_archived",
          "is_default",
          "is_including_admin_seat",
          "is_school",
          "disable_pixel",
          "is_sale",
          "sale_date",
          "annual_deal_size",
          // "members",
          "premium_website_purchase_count",
          "projects_limit_count",
          "seats_count",
          "screens_limit_count",
          "slug",
          "storybook_token",
          "storybook_file_id",
          "use_storybook_v2",
          "storybook_components_limit",
          "storybook_use_anima_proxy",
          "stripe_customer_id",
          "updated_at",
        ]);
        await this.updateTeam({
          id,
          payload: {
            ...defaults(payload, {
              storybook_components_limit: 15,
            }),
            ...(payload.is_sale
              ? {}
              : { sale_date: null, annual_deal_size: null }),
          },
        });
        this.$message.success("Team saved successfully");
        if (this.updatedProjectsLimitCount) {
          await this.updateLockedProjects();
        }
      } catch (error) {
        this.$notify.error({
          title: "Couldn't save changes :(",
          message: error.message,
        });
      } finally {
        this.unsetLoading("team");
      }
    },
    openStiggCustomer() {
      const url = getCustomerLink(this.team.id);
      window.open(url, "_blank");
    },
    displaySubscriptionDetails() {
      this.showSubscriptionDialog = true;
    },
    updateProjectsLimitCount() {
      this.updatedProjectsLimitCount = true;
      this.payload.projects_limit_count =
        this.getDefaultProjectLimitCount?.count;
    },
    updateScreensLimitCount() {
      this.updatedScreensLimitCount = true;
      this.payload.screens_limit_count =
        this.getDefaultScreenLimitCount?.count;
    },
    async updateLockedProjects() {
      const { id } = this.payload;
      await this.$api.get(`/team/unlock/${id}`);
      this.$message.success("Locked projects updated successfully");
    },
  },
  watch: {
    team(newValue) {
      this.payload = { ...newValue };
    },
  },
};
</script>

<style scoped></style>
